// extracted by mini-css-extract-plugin
export default {"content":"TarotReadingPage_content__nWJbs","cardsContainer":"TarotReadingPage_cardsContainer__MoKJC"};